import * as React from 'react';
import { connect } from 'react-redux';
import { SeverityDisplay } from '../../components/common';
import { ISeverityDisplayProps } from '../../components/common/SeverityDisplay';
import { IApplicationState } from '../../store';
import { ActionCreators as surveyBuilderActionCreators } from '../../store/SurveyBuilderStore';

const mapStateToProps = (state: IApplicationState, props: ISeverityDisplayProps) => ({
	canJump: state.surveyAdmin.surveyAdminSummary ? !state.surveyAdmin.surveyAdminSummary.hasBeenPublished : true,
});

export const SeverityDisplayContainer: React.ComponentType<any> = connect(mapStateToProps, { ...surveyBuilderActionCreators })(
	SeverityDisplay,
);
